<template>
  <div class="head main_box">
    <div class="row" id="headMenu">
      <div class="logo-icon">
        <img :src="logo_url" alt="松科智能" class="head_icon" @click="handleClickLogo" />
      </div>
      <div class="menu-box">
        <el-menu
          :default-active="active_index"
          mode="horizontal"
          @select="menuSelect"
          :backgroundColor="background_color"
          :textColor="text_color"
          :activeTextColor="active_text_color"
          :router="false"
          :collapseTransition="true"
          class="menu-container"
        >
          <template v-for="(item, index) in menu_list">
            <el-menu-item v-if="index < visibleNumber" :key="item.path" :index="item.path">{{ item.title }}</el-menu-item>
          </template>
          <el-submenu v-if="menu_list.length > visibleNumber" index="more" class="menu-more">
            <template slot="title">更多菜单</template>
            <template v-for="(item, index) in menu_list">
              <el-menu-item v-if="index >= visibleNumber" :key="item.path" :index="item.path" :popper-append-to-body="true">{{ item.title }}</el-menu-item>
            </template>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    logo_url() {
      return require('@/assets/logo/logo.png');
    },
    active_index() {
      const path = this.$route.path;
      return path;
    },
  },
  data() {
    return {
      background_color: '#013C60', // 菜单背景色
      text_color: '#FFFFFF', // 菜单文字颜色
      active_text_color: '#00A8CD', // 当前激活菜单的文字颜色
      menu_list: [
        {
          title: '首页',
          name: 'Home',
          path: '/home',
          width: 76,
          id: 0,
        },
        {
          title: '关于松科',
          name: 'About',
          path: '/about',
          width: 112,
          id: 1,
        },
        {
          title: '新闻中心',
          name: 'News',
          path: '/news',
          width: 112,
          id: 2,
        },
        {
          title: 'AI教育云平台',
          name: 'Education',
          path: '/education',
          width: 148,
          id: 3,
        },
        {
          title: 'AI教育产品',
          name: 'Product',
          path: '/product',
          width: 130,
          id: 4,
        },
        {
          title: 'AI教育方案',
          name: 'Scheme',
          path: '/scheme',
          width: 130,
          id: 5,
        },
        {
          title: '战略合作',
          name: 'Partner',
          path: '/partner',
          width: 112,
          id: 6,
        },
        {
          title: '开发者社区',
          name: 'Developer',
          path: '/developer',
          width: 130,
          id: 7,
        },
        {
          title: '教育社区',
          name: 'Community',
          path: '/community',
          width: 112,
          id: 8,
        },
      ],
      visibleNumber: 9,
    };
  },
  beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber);
  },
  mounted() {
    this.setVisibleNumber();
  },
  methods: {
    // 根据宽度计算设置显示栏数
    setVisibleNumber() {
      const width = document.getElementById('headMenu').clientWidth - 300;
      let menu_width = 0;
      let index = 0;
      for (let i = 0; i < this.menu_list.length; i++) {
        menu_width = menu_width + this.menu_list[i].width;
        if (width <= menu_width) {
          index--;
          break;
        }
        index++;
      }
      this.visibleNumber = index;
    },
    // 选择菜单
    menuSelect(index, path) {
      if (index == '/developer') {
        window.open('https://dc.aispore.cn', '_blank');
        return;
      }
      if (index == '/community') {
        window.open('https://www.aispore.cn/home', '_blank');
        return;
      }
      this.$router.push({
        path: index,
      });
    },
    // 点击logo
    handleClickLogo() {
      this.$router.push({ path: '/home' });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
.head {
  height: @head-height;
  background-color: @head-background-color;
  box-shadow: 0px 1px 22px 1px rgba(1, 60, 96, 0.5);
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  .row {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .logo-icon {
      display: flex;
      align-content: center;
      align-items: center;
      width: 250px;
      img {
        width: 122px;
        height: 40px;
      }
    }
    .menu-box {
      flex: 1;
      .el-menu--horizontal > .el-menu-item {
        font-size: @font-18;
        box-sizing: border-box;
        // padding: 0;
        // min-width: 130px;
        // max-width: 130px;
      }
      .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: 2px solid @head-background-color !important;
      }
      .el-menu.el-menu--horizontal {
        border-bottom: none;
      }
      /deep/ .el-submenu__title {
        font-size: @font-18;
        box-sizing: border-box;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/components/header.vue